<template>
  <WTooltip :position="tooltipPosition" :label="title">
    <WButton
      :icon="icon"
      icon-button
      size="small"
      variant="tertiary"
      :disabled="disabled"
      @click="$emit('click')"
    />
  </WTooltip>
</template>

<script>
import { WButton, WTooltip } from '@alice-health/wonderland-vue'

export default {
  components: { WButton, WTooltip },
  props: {
    title: { type: String, default: '' },
    icon: { type: String, required: true },
    tooltipPosition: {
      type: String,
      default: 'bottom'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click']
}
</script>
